import loadable from '../../utilities/loadable'

export const ModifyProductMetadata = loadable(() =>
  import('./ModifyProductMetadata')
)
